'use strict';

function CustomerPayments() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [];

  this.retrievePaymentMethods = function () {
    var def = $.Deferred();
    if (this.presenter.hasAction('account.index_payment_methods')) {
      if (this.presenter.models.payments) {
        this.presenter.updateModel('payments', null, this._onRetrievePaymentMethods.bind(this, def));
      } else {
        this.presenter.createModel('payments', { action: 'account.index_payment_methods' }, this._onRetrievePaymentMethods.bind(this, def));
      }
    } else {
      def.reject();
    }
    return def;
  };

  this.createPaymentMethod = function (nonce, callback) {
    if (this.presenter.hasAction('payments.create_payment_method')) {
      this.presenter.performAction('payments.create_payment_method', {
        payment_method_nonce: nonce
        /* "payment_method_nonce": "fake-processor-declined-visa-nonce" */
      }, this._onCreatePaymentMethod.bind(this, callback));
    } else {
      callback();
    }
  };

  this.deletePaymentMethod = function (paymentId, callback) {
    if (this.presenter.hasAction('payment_' + paymentId + '.delete_payment_method')) {
      this.presenter.performAction('payment_' + paymentId + '.delete_payment_method', null, this._onDeletePaymentMethod.bind(this, paymentId, callback));
    } else {
      callback();
    }
  };

  this._onCreatePaymentMethod = function (callback, data, response) {
    if (response === 200) {
      this.presenter.createModel('payment_' + data.id, { data: data });
      this.presenter.updateModel('payments', null, callback.bind(this, data, response));
    } else {
      callback(data, response);
    }
  };

  this._onDeletePaymentMethod = function (paymentId, callback, data, response) {
    if (response === 200) {
      delete this.presenter.models['payment_' + paymentId];
      this.presenter.updateModel('payments', null, callback.bind(null, data, response));
    }
  };

  this._onRetrievePaymentMethods = function (def, data) {
    if (data && data.payment_methods.length > 0) {
      var modelsUpdated = {};
      // Create/update a model for each payment method
      for (var i = 0; i < data.payment_methods.length; i++) {
        var paymentMethod = data.payment_methods[i];
        var modelName = 'payment_' + paymentMethod.id;
        modelsUpdated[modelName] = true;
        if (this.presenter.models[modelName]) {
          this.presenter.updateModel(modelName, data.payment_methods[i]);
        } else {
          this.presenter.createModel('payment_' + paymentMethod.id, {
            data: data.payment_methods[i]
          });
        }
      }

      for (var key in this.presenter.models) {
        if (key.indexOf('payment_') === 0 && !modelsUpdated[key]) {
          delete this.presenter.models[key];
        }
      }
    }
    def.resolve();
  };

  this._getCountPaymentMethods = function () {
    var count = 0;
    var paymentMethods = this.presenter.models.payments;
    if (paymentMethods && paymentMethods._initialized && paymentMethods.payment_methods && paymentMethods.payment_methods.length) {
      count = paymentMethods.payment_methods.length;
    }
    return count;
  };

  this._getMaskedCCNumberFromPaymentMethod = function (paymentMethodRef) {
    return 'xxxx - xxxx - xxxx - ' + paymentMethodRef.masked_number.slice(-4);
  };

  this.init = function () {};

  this.initAllReady = function () {};

  this.destroy = function () {};
}